import Modal from '@components/Modal'

const OnDemandParkingActivateModal = ({ onCancel, onConfirm }) => (
    <Modal
        size="small"
        onClose={onCancel}
        header={<T>dashboard.on.demand.parking.activate.confirm.title</T>}
        buttons={[
            {
                label: <T>dashboard.on.demand.parking.activate.confirm.cancel</T>,
                onClick: onCancel,
                btnStyle: 'outline',
            },
            {
                label: <T>dashboard.on.demand.parking.activate.confirm.activate</T>,
                onClick: onConfirm,
                btnStyle: 'primary',
            },
        ]}>
        <p className="text-large mb-3">
            <T>dashboard.on.demand.parking.activate.confirm.description1</T>
        </p>
        <p className="text-large mb-0">
            <T>dashboard.on.demand.parking.activate.confirm.description2</T>
        </p>
    </Modal>
)

export default OnDemandParkingActivateModal
